/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIContractStatusEnum } from './APIContractStatusEnum';
import {
    APIContractStatusEnumFromJSON,
    APIContractStatusEnumFromJSONTyped,
    APIContractStatusEnumToJSON,
} from './APIContractStatusEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedContractRequest
 */
export interface APIPatchedContractRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedContractRequest
     */
    offer?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIPatchedContractRequest
     */
    editors?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedContractRequest
     */
    shippingAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedContractRequest
     */
    billingAddress?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIPatchedContractRequest
     */
    desiredDelivery?: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIPatchedContractRequest
     */
    latestDelivery?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof APIPatchedContractRequest
     */
    priorityShipping?: boolean;
    /**
     * 
     * @type {APIContractStatusEnum}
     * @memberof APIPatchedContractRequest
     */
    contractStatus?: APIContractStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedContractRequest
     */
    comment?: string | null;
    /**
     * Price that gets selected by the user from the Prices of the Offer. Format: {'200': '123.45'}
     * @type {{ [key: string]: any; }}
     * @memberof APIPatchedContractRequest
     */
    price?: { [key: string]: any; };
}



/**
 * Check if a given object implements the APIPatchedContractRequest interface.
 */
export function instanceOfAPIPatchedContractRequest(value: object): value is APIPatchedContractRequest {
    return true;
}

export function APIPatchedContractRequestFromJSON(json: any): APIPatchedContractRequest {
    return APIPatchedContractRequestFromJSONTyped(json, false);
}

export function APIPatchedContractRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedContractRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'offer': json['offer'] == null ? undefined : json['offer'],
        'editors': json['editors'] == null ? undefined : json['editors'],
        'shippingAddress': json['shipping_address'] == null ? undefined : json['shipping_address'],
        'billingAddress': json['billing_address'] == null ? undefined : json['billing_address'],
        'desiredDelivery': json['desired_delivery'] == null ? undefined : (new Date(json['desired_delivery'])),
        'latestDelivery': json['latest_delivery'] == null ? undefined : (new Date(json['latest_delivery'])),
        'priorityShipping': json['priority_shipping'] == null ? undefined : json['priority_shipping'],
        'contractStatus': json['contract_status'] == null ? undefined : APIContractStatusEnumFromJSON(json['contract_status']),
        'comment': json['comment'] == null ? undefined : json['comment'],
        'price': json['price'] == null ? undefined : json['price'],
    };
}

export function APIPatchedContractRequestToJSON(value?: APIPatchedContractRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'offer': value['offer'],
        'editors': value['editors'],
        'shipping_address': value['shippingAddress'],
        'billing_address': value['billingAddress'],
        'desired_delivery': value['desiredDelivery'] == null ? undefined : ((value['desiredDelivery']).toISOString()),
        'latest_delivery': value['latestDelivery'] == null ? undefined : ((value['latestDelivery']).toISOString()),
        'priority_shipping': value['priorityShipping'],
        'contract_status': APIContractStatusEnumToJSON(value['contractStatus']),
        'comment': value['comment'],
        'price': value['price'],
    };
}

